import React, { useState, useEffect, useRef, useMemo } from 'react';
import styles from "./index.module.scss";
import Axios from "axios";
// import { QUESTION_LIST_URL } from "./API_URLS";
import { QUESTION_LIST_URL } from "../../utils/Shared/constant";
import Step1Selector from "./Step1Selector";
import Step2Selector from "./Step2Selector";
import Step3Selector, { LISTEN_CHART_TYPE_CHANGE } from "./Step3Selector";
import { LISTEN_STEP_CONDITION_CHANGE } from "./Step2Selector";
import DATA_TYPES from './DATA_TYPES';
import { Link } from 'react-router-dom';
function CustomDataPage({ onSubmit }) {
    const [questions, setQuestions] = useState([]);
    const [chartSpec, setChartSpec] = useState({
        step1Question: null,
        step2Question: null,
        step3Question: null,
        chartType: null,
    });
    const chartSpecRef = useRef(chartSpec);


    const handleSubmit = () => {
        onSubmit(chartSpec);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        const submitBtn = document.getElementById("submit-btn");
        submitBtn.disabled = true;

        Axios.get(QUESTION_LIST_URL).then((res) => {
            setQuestions(res.data.Result);
        });

        LISTEN_STEP_CONDITION_CHANGE((e) => {
            const { step1Question, step2Question, step3Question } = e.detail;
            const newChartSpec = {
                ...chartSpecRef.current,
                step1Question,
                step2Question,
                step3Question,
            }
            chartSpecRef.current = newChartSpec;
            setChartSpec({
                step1Question,
                step2Question,
                step3Question,
            });
        });

        LISTEN_CHART_TYPE_CHANGE((e) => {
            const { chartType } = e.detail;

            const newChartSpec = {
                ...chartSpecRef.current,
                chartType,
            }
            chartSpecRef.current = newChartSpec;
            setChartSpec(newChartSpec);
        });

    }, []);

    


    useEffect(() => {
        const { step1Question, step2Question, step3Question } = chartSpec;
        if (!step1Question && !step2Question && !step3Question) return;

        const submitBtn = document.getElementById('submit-btn');

        if (!chartSpec.chartType) {
            submitBtn.disabled = true;
            return;
        }

        if (
            step1Question.AnswerTypeName === DATA_TYPES.數值型單數
        ) {

            if (step2Question) {
                submitBtn.disabled = false;
            } else if (step3Question) {
                submitBtn.disabled = false;
            } else {
                submitBtn.disabled = true;
            }
           
        } else {
            submitBtn.disabled = false;
        }
    }, [chartSpec]);

    
    return (
        <div className={styles.customDataPage}>
            <div className={styles.breadcrumbsBlock}>
                <div className={styles.breadcrumbs}>
                    {/* <Link to="/statistics/ChishangEarthquake">
                        <span>
                            0918 池上地震-花東地區地震認知與避難行為調查 (2023)
                        </span>
                    </Link>
                    <span className={styles.breadcrumbsSeparator}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                        >
                            <line
                                x1="11.6036"
                                y1="0.728553"
                                x2="0.996952"
                                y2="11.3352"
                                stroke="#5B5B5B"
                            />
                        </svg>
                    </span>
                    <span>
                        <b>客製化專區</b>
                    </span> */}
                </div>
                <div className={styles.chartDataCTA}>
                    <Link
                        to="/statistics/ChishangEarthquake/chart-data"
                        className={styles.chartDataLink}
                    >
                        前往主題圖表
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M10 8L14 12L10 16"
                                stroke="#A479E9"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </Link>
                </div>
            </div>
            <div className={styles.heroSection}>
                <div className={styles.heroSectionText}>
                    <h1>客製化專區</h1>
                    <p>Customization</p>
                </div>
            </div>
            <div className={styles.container}>
                <div className={styles.wrapper}>
                    <div>
                        <Step1Selector questions={questions} />
                    </div>
                    <div>
                        <div>
                            <Step2Selector />
                        </div>
                        <div>
                            <Step3Selector />
                        </div>
                    </div>
                </div>
                <button
                    id="submit-btn"
                    className={styles.submitBtn}
                    onClick={handleSubmit}
                >
                    生成圖表
                </button>
            </div>
        </div>
    );
}

export default CustomDataPage;